var $ = require('jquery');

var self = {};

self.initialise = function() {
  var isMobile = window.matchMedia('only screen and (max-width: 767px)').matches;

  //Normal Accordions
  $('.accordion-title').append('<span class="fa fa-chevron-down"></span>');
  if (isMobile) {
    $('.accordion-content').hide();
  } else {
    $('.accordion-title').addClass('open');
  }
  $('.accordion-title').css({
    cursor: 'pointer',
  });
  $('.accordion-title').on('click', function() {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this)
        .next('.accordion-content')
        .slideUp();
    } else {
      //if you want multiple accordion items open remove this line
      //$(this).parent().find('.accordion-title.open').removeClass('open').children('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down').parent().next('.accordion-content').slideUp();
      $(this).addClass('open');
      $(this)
        .next('.accordion-content')
        .slideDown();
    }
  });
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/accordion.js